"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconRangeEu = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconRangeEu = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, (0, _extends2.default)({
  width: 10,
  height: 26,
  viewBox: "0 0 10 26"
}, props), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("path", {
  id: "icon-range-eu_svg__a",
  d: "M5.757 6.999c.176 0 .315-.005.416-.013.1-.01.17-.033.21-.07.04-.038.054-.094.043-.169a1.762 1.762 0 00-.08-.305L4.185.295a.456.456 0 00-.076-.161.267.267 0 00-.15-.088 1.335 1.335 0 00-.295-.038 13.364 13.364 0 00-.951 0c-.111.005-.199.018-.262.038s-.109.048-.137.085a.524.524 0 00-.076.148L.085 6.43c-.043.125-.07.225-.081.3-.011.075.002.133.038.174.035.041.1.067.194.078A6.148 6.148 0 001 6.988a.829.829 0 00.22-.041.234.234 0 00.114-.08.432.432 0 00.057-.126l.442-1.356h2.623l.47 1.393a.35.35 0 00.054.113c.021.028.06.05.113.067.054.016.132.027.235.032.103.005.246.008.43.008zm-1.63-2.696h-1.98l.987-2.947h.005l.988 2.947z"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "icon-range-eu_svg__b",
  d: "M3.741 23.135a5.622 5.622 0 001.033-.098 5.233 5.233 0 00.886-.249c.107-.043.178-.1.212-.174a.59.59 0 00.052-.257v-2.52a.548.548 0 00-.025-.173.371.371 0 00-.071-.13.31.31 0 00-.248-.107H3.425a.124.124 0 00-.079.027.202.202 0 00-.059.083.564.564 0 00-.037.15 1.818 1.818 0 00-.012.229c0 .176.016.3.049.374.033.074.079.11.138.11h1.207v1.468a1.601 1.601 0 01-.394.147 1.933 1.933 0 01-.429.049c-.295 0-.565-.048-.81-.142a1.686 1.686 0 01-.628-.42 1.959 1.959 0 01-.407-.693 2.883 2.883 0 01-.145-.957c0-.329.047-.63.143-.902.095-.273.231-.506.409-.7.177-.194.39-.344.64-.45.25-.106.529-.159.838-.159.289 0 .543.03.76.088.22.059.407.122.565.191.158.068.284.132.38.19.095.06.164.089.206.089a.12.12 0 00.077-.025.176.176 0 00.054-.085.75.75 0 00.034-.164c.009-.069.013-.15.013-.245 0-.163-.01-.286-.03-.37a.409.409 0 00-.096-.192 1.03 1.03 0 00-.234-.162 2.293 2.293 0 00-.421-.173 4.581 4.581 0 00-1.348-.194c-.502 0-.958.077-1.367.23a2.891 2.891 0 00-1.047.663c-.289.289-.512.64-.67 1.052a3.883 3.883 0 00-.237 1.397c0 .502.074.951.222 1.348.148.396.361.732.64 1.007.28.276.62.486 1.023.631.402.146.858.218 1.367.218z"
})), /*#__PURE__*/_react.default.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: "#FFF",
  d: "M0 0h10v26H0z"
}), /*#__PURE__*/_react.default.createElement("g", {
  fillRule: "nonzero",
  transform: "translate(2.012 1.444)"
}, /*#__PURE__*/_react.default.createElement("use", {
  xlinkHref: "#icon-range-eu_svg__a"
}), /*#__PURE__*/_react.default.createElement("use", {
  fill: "#231C1E",
  xlinkHref: "#icon-range-eu_svg__a"
})), /*#__PURE__*/_react.default.createElement("path", {
  stroke: "#1C1A00",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.273,
  d: "M5.195 16.032v-5.81m1.559 1.515l-1.559-1.539-1.564 1.539"
}), /*#__PURE__*/_react.default.createElement("g", {
  fillRule: "nonzero",
  transform: "translate(2.012 1.444)"
}, /*#__PURE__*/_react.default.createElement("use", {
  xlinkHref: "#icon-range-eu_svg__b"
}), /*#__PURE__*/_react.default.createElement("use", {
  xlinkHref: "#icon-range-eu_svg__b"
}))));
exports.IconRangeEu = IconRangeEu;
//# sourceMappingURL=IconRangeEu.js.map